function getCookie(name: string): string | null {
	const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
	return match ? match[2] : null;
}

function setCookie(name: string, value: string, days: number): void {
	const date = new Date();
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function initCookieBanner(): void {
	const banner = document.getElementById('cookie-popup');

	if (!banner) {
		return;
	}

	const force: boolean = /force-cookie/.test(location.search);

	if (getCookie('procookie') && !force) {
		banner.remove();
		return;
	}

	const closeButton = banner.querySelector<HTMLButtonElement>('.cookie-banner__close');

	const addCookie = (): void => {
		setCookie('procookie', 'true', 90);
	};

	const hideBanner = (): void => {
		addCookie();
		banner.style.display = 'none';
	};

	banner.style.display = 'block';

	closeButton?.addEventListener('click', hideBanner);

	banner.addEventListener('click', (event: MouseEvent): void => {
		if ((event.target as HTMLElement).tagName === 'A') {
			addCookie();
		}
	});
}

document.addEventListener('DOMContentLoaded', initCookieBanner);
